import React from 'react';
import { motion } from 'framer-motion';
import { productions, type Production } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { SmartImage } from './SmartImage';
function ProductionCard({
  production
}: {
  production: Production;
}) {
  return <li className="w-[240px] shrink-0 sm:w-[280px] lg:w-[320px]" role="listitem" data-id="element-296" data-mp="1ucasikjb7xdy">
      <article className="group relative overflow-hidden rounded-card border border-white/[0.07] bg-graphite transition-all duration-500 hover:-translate-y-1 hover:border-gold/50 hover:shadow-[0_30px_80px_-40px_rgba(245,197,24,0.5)]" data-id="element-297" data-mp="1pd7zjyglthmc">
        <SmartImage src={production.image} alt={`${production.category} — ${production.title}`} wrapperClassName="aspect-[4/5] w-full" className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]" data-id="element-298" data-mp="1gdkun2oo1toj" />
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-ink via-ink/70 to-transparent" data-id="element-299" data-mp="35srcmr5t7275" />
        <div className="absolute inset-x-0 bottom-0 p-5" data-id="element-300" data-mp="rgkndke70dl7">
          <span className="font-sans text-[10px] uppercase tracking-[0.28em] text-gold" data-id="element-301" data-mp="rdzmoypms3p1">
            {production.category}
          </span>
          <h3 className="mt-1.5 font-display text-lg uppercase leading-tight tracking-wide text-white lg:text-xl" data-id="element-302" data-mp="ieupbvpt2geg">
            {production.title}
          </h3>
        </div>
      </article>
    </li>;
}
export function Productions() {
  return <section id="producciones" className="relative w-full overflow-hidden bg-ink py-20 sm:py-24 lg:py-32" aria-labelledby="producciones-title" data-id="element-303" data-mp="1b6e8xgqbdwgz">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/3 hidden h-72 w-[60%] -translate-x-1/2 rounded-full bg-gold/[0.05] blur-3xl lg:block" data-id="element-304" data-mp="11d77u82lx2mp" />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-10" data-id="element-305" data-mp="1tvkynnpizoca">
        <SectionHeading eyebrow="Producciones" title={<span id="producciones-title" data-id="element-307" data-mp="23ofbqecsf8fw">
              Formatos que ya están <span className="text-gold" data-id="element-308" data-mp="1ys85ekghbuxf">al aire</span>
            </span>} description="Una selección de piezas producidas bajo la marca NORBERTH Presenta." data-id="element-306" data-mp="23qjjx8hpytlz" />
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 22
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="marquee relative mt-12 lg:mt-16" data-id="element-309" data-mp="1pqh1nl5i1y67">
        <div className="marquee-viewport group flex w-full overflow-hidden" data-id="element-310" data-mp="1b1kt7mzj6j52">
          <ul className="marquee-track flex shrink-0 gap-5 pr-5" aria-label="Producciones de NORBERTH Presenta" data-id="element-311" data-mp="163163j97b1b4">
            {productions.map(production => <ProductionCard key={production.id} production={production} data-id="element-312" data-mp="x2csgpnpz2yr" />)}
          </ul>
          <ul className="marquee-track flex shrink-0 gap-5 pr-5" aria-hidden="true" data-id="element-313" data-mp="38pyhhqwk5sc7">
            {productions.map(production => <ProductionCard key={`clone-${production.id}`} production={production} data-id="element-314" data-mp="3dqvza2dnokd6" />)}
          </ul>
        </div>

        <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-ink to-transparent sm:w-28" data-id="element-315" data-mp="3mo67fev6ftdv" />
        <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-ink to-transparent sm:w-28" data-id="element-316" data-mp="2u00q723c0mis" />
      </motion.div>
    </section>;
}